import React from "react";
import { Route, IndexRoute } from "react-router";

//department landing page
import DepartmentsOverview from "../Department";

//globals
import App from "./appContainer";
import Login from "../Login";
import ContentComponent from "./contentComponent";
import CreateNewSalary from "../Project/Salary";
import Product from "../Product";
import Users from "../Users";
import User from "../Users/User";
import Projects from "../Projects";
import Project from "../Projects/Project";
import Clients from "../Clients";
import Client from "../Clients/Client";
import CustomPricelist from "../CustomPricelist";
import APV from "../APV";

//tilbud department
import CreateProjectWizard from "../Project/CreateProject";
import ActivityOverview from "../Project/ActivityOverview";
import WeekOverview from "../Project/WeekOverview";
import ProjectDashboard from "../Project/Dashboard";
import RegisterActivities from "../Project/RegisterActivities";
import RegisterActivity from "../Project/RegisterActivities/RegisterActivity";

//other departments
import Kanban from "../ShortTermProjects/Kanban";
import Workplace from "../ShortTermProjects/Workplace";
import DailyReport from "../ShortTermProjects/Workplace/DailyReport";
import Overview from "../ShortTermProjects/Workplace/Overview";
import Images from "../ShortTermProjects/Workplace/Images";
import PCalc from "../ShortTermProjects/Workplace/PCalc";
import Invoice from "../ShortTermProjects/Workplace/Invoice";
import Tilbud from "../ShortTermProjects/Workplace/Tilbud";
import Arbejdsmiljo from "../ShortTermProjects/Workplace/Arbejdsmiljo";
import Docs from "../ShortTermProjects/Workplace/Arbejdsmiljo/docs";

import auth from "../Login/authService";

// onEnter callback to validate authentication in private routes
const requireAuth = () => {
  if (!auth.loggedIn()) {
    var redirect = localStorage.getItem("redirect");
    if (redirect) {
      if (!redirect.startsWith("http")) {
        localStorage.setItem("redirect", auth.hostname);
      }
    } else {
      localStorage.setItem("redirect", auth.hostname);
    }
    window.location.replace(auth.hostname + "/login");
  } else {
    if (auth.getProfile().email === "pladsen@ceas.dk") {
      if (window.location.pathname !== "/materiel") {
        window.location.replace(auth.hostname + "/materiel");
      }
    }
    var redirect = localStorage.getItem("redirect");
    if (redirect) {
      if (redirect.startsWith("http")) {
        window.location.replace(redirect);
        localStorage.setItem("redirect", null);
      }
    }
  }
};

const requireRole = () => {
  if (auth.getProfile().role === "Formand") {
    window.location.replace(auth.hostname);
  }
};

const parseAuthHash = () => {};

export default (
  <Route component={App} auth={auth}>
    <Route path="/login" component={Login} onEnter={parseAuthHash} />
    <Route path="/" component={ContentComponent} onEnter={requireAuth}>
      <IndexRoute component={DepartmentsOverview} />
      <Route path="lon" component={CreateNewSalary} />
      <Route path="materiel" component={Product} />
      <Route path="users" component={Users} />
      <Route path="users/:id" component={User} />
      <Route path="projects" component={Projects} />
      <Route path="projects/:id" component={Project} />
      <Route path="clients" component={Clients} />
      <Route path="clients/:id" component={Client} />
      <Route path="prislister" component={CustomPricelist} />
      <Route path="apv" component={APV} />

      {/*Tilbud department*/}
      <Route path="tilbud">
        <IndexRoute component={ProjectDashboard} />
        <Route path="opretsag" component={CreateProjectWizard} />
        <Route path="sag/:projectNumber" component={ActivityOverview} />
        <Route
          path="sag/:projectNumber/rediger"
          component={CreateProjectWizard}
        />
        <Route
          path="sag/:projectNumber/registrer"
          component={RegisterActivities}
        >
          <Route path=":activityId" component={RegisterActivity} />
        </Route>
        <Route path="sag/:projectNumber/ugeoversigt" component={WeekOverview} />
      </Route>
      {/*all other departments*/}
      <Route path="afdeling/:departmentId">
        <IndexRoute component={Kanban} />
        <Route path="arbejdssted/:workplaceId" component={Workplace}>
          <Route path="oversigt" component={Overview}>
            <Route path=":someWrongId" component={Overview} />
          </Route>
          <Route path="dagrapport" component={DailyReport}>
            <Route path=":dailyreportId" component={DailyReport} />
          </Route>
          <Route path="billeder" component={Images} />
          <Route path="pkalk" component={PCalc} />
          <Route path="invoice" component={Invoice} onEnter={requireRole} />
          <Route path="estimat" component={Tilbud} onEnter={requireRole} />
          <Route path="arbejdsmiljo" component={Arbejdsmiljo} />
          <Route path="docs" component={Docs} />
        </Route>
      </Route>
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/App/MainClient/routes.jsx